module.exports = __webpack_public_path__ + "static/media/content-1.95c28250.png";